// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*@import url('https://fonts.googleapis.com/css?family=Open+Sans|Pacifico');*/

body {
    margin: 0;
  }
  
p {
  margin: 0;
  display: inline-block;
}

.App {
  background-color: lightgray;
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
}


.chatroom {
  /* width: 360px;
  height: 600px; */
  height: 100%;
  width: 100%;
  /* max-width: 500px; */
  /* margin-top: 12vh; */
  background-color: rgba(0,0,0, .7);
  border-radius: 5px;
  /* overflow: hidden; */
  box-shadow: 0 0 8px 0 rgba(0,0,0, 0.3);
  /* position: absolute; */
  /* right: 4%;
  width: 23%;
  height: 90%;
  top: 9%; */
  
  /* display: flex;
  flex-direction: column;
  grid-area: videopanel; */
}

.chatroom h3 {
  /* font-family: 'Pacifico', cursive; */
  background-color: rgba(127, 204, 242, 0.7);
  color: #FFF;
  margin: 0;
  height: 40px;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.original-image{
  user-drag: none;
  -webkit-user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
}

.chatroom .chats {
  box-sizing: border-box;
  padding: 0 20px;
  margin: 10px 0 0;
  /* height:100%; */
  height: calc(100% - 90px);
  /* height: 87%; */
  /* height: 600px; */
  /* overflow-y: hidden; */
  overflow-y: auto;
  min-height: 50%;
}

.chatroom .chats .chat {
  background: rgba(255, 255, 255, 0.8);
  position: relative;
  padding: 5px 13px;
  font-size: 14px;
  border-radius: 10px;
  list-style: none;
  float: left;
  clear: both;
  margin: 10px 0;
  max-width: 250px;
}

.w-full {
  width: 100%;
}
/* .h-full {
  height: 100%;
} */

.full-screen-image{
  width: 100%;
  /* height: 100%; */
  object-fit: contain;
  position: absolute
}
.absolute{
  position: absolute;
}

.pointer-events-none{
  pointer-events: none;
}

.chatroom .chats .chat img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  position: absolute;
  top: -10px;
  left: 0px;
}

.chatroom .chats .chat.right {
  float: right;
  clear: both;
}

/*.chatroom .chats .chat a {
  text-decoration: none;
  color:#3498DB;
}*/


.chatroom .input {
  min-height: 40px;
  /* max-height: 100px; */
  /* width: 100%; */
  background: rgba(147, 215, 249, 0.7);
  display: flex;
  flex-direction: row;
  align-items: center;

  /* position: absolute;
  bottom: 0; */
}

/* */
  
.chatroom .input input[type="text"] {
  background: rgba(255, 255, 255, 0.5);
  outline: 0;
  border: 2px solid #9ad4ed;
  padding: 0 5px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  margin-left: 10px;
  height: 30px;
  width: 230px;
  box-sizing: border-box;
  font-size: 14px;
}

.chatroom .input  img[type="popup"] {
  background: transparent;
  border: 1px solid #9ad4ed;
  height: 30px;
  width: 30px;
  font-size: 14px;
  box-sizing: border-box;
  /* border-top-right-radius: 5px;
  border-bottom-right-radius: 5px; */
  transition: all 0.3s ease;

}
.chatroom .input  img[type="popup"]:hover {
  cursor: pointer;
  background: #9ad4ed;
  color: #FFF;
}
.chatroom .input input[type="button"] {
  background: transparent;
  border: 1px solid #9ad4ed;
  height: 40px;
  /* width: 80px; */
  font-size: 14px;
  box-sizing: border-box;
  /* border-top-right-radius: 5px;
  border-bottom-right-radius: 5px; */
  transition: all 0.3s ease;
}


.chatroom .input input[type="button"]:hover {
  background: #9ad4ed;
  color: #FFF;
}
  
.chatroom #button{
  background: transparent;
  border: 1px solid #9ad4ed;
  /* margin-right: 10px; */
  height: 40px;
  /* width: 50px; */
  font-size: 14px;
  box-sizing: border-box;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  transition: all 0.3s ease;
}
  
.chatroom .input input[type="submit"]:hover {
  background: #9ad4ed;
  color: #FFF;
}

.modal {
  display: none;
  position: fixed;
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.25);
  overflow: scroll;
}
  
.modal_content {
    background-color: white;
    position: absolute;
    top: 20%;
    left: 25%;
    width: 50%;
    height: 100%;
    padding: 20px;
    border-radius: 5px;
    border: 2px solid black;
  }

.default-button:hover, .group-button:hover{
    color: #FFFFFF;
    background-color: darkmagenta;
    transition-duration: 0.5s;
}
  
.content { 
      /* display: none;  */
    position: fixed; 
    top: 30%; 
    left: 18%; 
    width: 65%; 
    height: 60%; 
    /* padding: 20px;  */
    background-color: white; 
    z-index:999; 
    overflow: auto; 
    /* transform: translate(-10%, -10%); */
    /* margin:auto; */
    /* border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px; */
    border: 1.5px solid black; ;
} 

#gallery  {
  position: relative;
  background-color: #FFFFFF;
  overflow: scroll;
  border: 1px #6C757D solid;
  border-radius: 5px;
  /* margin: auto; */
  margin:8px;
  width: 95%;
  height: 250px;
  bottom: 300px;
}

/* #float-span:hover{
  cursor: pointer;
  border-top: 10px solid aquamarine;    
} */

#float-span:hover{
  cursor: pointer;
  border-left: 10px solid aquamarine;    
}

.thingmoji{
  float: left;
  margin: 2px;
  /* position:absolute */
}

:root{
  --pseudo-border-bottom: "";
  --pseudo-border-top:"10px solid white";
  --pseudo-bottom:"-10px";
  --pseudo-top:"";
}

.image-bubble::after{
    content: '';
    position: absolute;
    bottom: var(--pseudo-bottom);
    top:var(--pseudo-top);
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: var(--pseudo-border-top);
    border-bottom: var(--pseudo-border-bottom);
}
.thingmoji:hover{
  cursor: pointer;
  transform: scale(1.1);
}

#image-peek{
  position: absolute;
  /* display: inline-block; */
  border-radius: 10px;
  background-color: white;
  border: 1px solid #ccc;
  padding: 10px;
  position:absolute;
  z-index:"100";
   width: 100px;
   height: 100px;
  /* position:absolute */
}
#image-peek::after{
  content: '';
  position: absolute;
  top: "-10px";
  /* --pseudo-border-top:"10px solid white"; */
  /* top:var(--pseudo-top); */
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: "10px solid white";
  /* border-bottom: var(--pseudo-border-bottom); */
}

.thingmoji-group {
  background: transparent;
  border: 1px solid #9ad4ed;
  height: 30px;
  width: 80px;
  font-size: 14px;
  box-sizing: border-box;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.thingmoji-group:hover {
  background: #9ad4ed;
  color: #FFF;
}

#delete, #new {
  background: #9ad4ed80;
  color: #6C757D;
  box-sizing: border-box;
  border-radius: 5px;
  transition: all 0.3s ease;
}

#delete:hover, #new:hover {
  background: #9ad4ed;
  color: #FFFFFF;
}

.font {
  font-family: "Pacifico", cursive;
}

.popup {
  border: #6C757D solid 1px;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.8);
}

*::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
*::-webkit-scrollbar-thumb {
  border-radius: 5px;
  box-shadow: inset 0 0 5px transparent;
  background: #6C757D88;
}
*::-wbkit-scrollbar-track {
  border-radius: 5px;
  box-shadow: inset 0 0 5px transparent;
  background: transparent;
}
*::-webkit-scrollbar-corner{
  border-radius: 5px;
  background-color: transparent;
}
*::-webkit-scrollbar-thumb:hover {
  background: #6C757DCC;
}
*::-webkit-scrollbar-thumb:active {
  background: #6C757D;
}
`, "",{"version":3,"sources":["webpack://./src/chat/Chat.css"],"names":[],"mappings":"AAAA,6EAA6E;;AAE7E;IACI,SAAS;EACX;;AAEF;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE;kBACgB;EAChB,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,sBAAsB;EACtB,sCAAsC;EACtC,wBAAwB;EACxB;;;YAGU;;EAEV;;0BAEwB;AAC1B;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,WAAW;EACX,SAAS;EACT,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;AACA;;GAEG;;AAEH;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB;AACF;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;;;EAGE;;;AAGF;EACE,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;;EAEnB;cACY;AACd;;AAEA,IAAI;;AAEJ;EACE,oCAAoC;EACpC,UAAU;EACV,yBAAyB;EACzB,cAAc;EACd,2BAA2B;EAC3B,8BAA8B;EAC9B,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB;oCACkC;EAClC,yBAAyB;;AAE3B;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB;oCACkC;EAClC,yBAAyB;AAC3B;;;AAGA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,wBAAwB;EACxB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,uBAAuB;EACzB;;AAEF;IACI,cAAc;IACd,6BAA6B;IAC7B,yBAAyB;AAC7B;;AAEA;MACM,oBAAoB;IACtB,eAAe;IACf,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;IACX,cAAc;IACd,sCAAsC;IACtC,iBAAiB;IACjB;;;sCAGkC;IAClC,yBAAyB;AAC7B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,aAAa;EACb,aAAa;AACf;;AAEA;;;GAGG;;AAEH;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,uBAAuB;EACvB,eAAe;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,4BAA4B;IAC5B,qBAAqB;IACrB,SAAS;IACT,2BAA2B;IAC3B,QAAQ;IACR,SAAS;IACT,mCAAmC;IACnC,oCAAoC;IACpC,oCAAoC;IACpC,0CAA0C;AAC9C;AACA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,aAAa;GACZ,YAAY;GACZ,aAAa;EACd,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,4CAA4C;EAC5C,2BAA2B;EAC3B,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,iCAAiC;EACjC,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB","sourcesContent":["/*@import url('https://fonts.googleapis.com/css?family=Open+Sans|Pacifico');*/\r\n\r\nbody {\r\n    margin: 0;\r\n  }\r\n  \r\np {\r\n  margin: 0;\r\n  display: inline-block;\r\n}\r\n\r\n.App {\r\n  background-color: lightgray;\r\n  height: 100vh;\r\n  width: 100vw;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n\r\n.chatroom {\r\n  /* width: 360px;\r\n  height: 600px; */\r\n  height: 100%;\r\n  width: 100%;\r\n  /* max-width: 500px; */\r\n  /* margin-top: 12vh; */\r\n  background-color: rgba(0,0,0, .7);\r\n  border-radius: 5px;\r\n  /* overflow: hidden; */\r\n  box-shadow: 0 0 8px 0 rgba(0,0,0, 0.3);\r\n  /* position: absolute; */\r\n  /* right: 4%;\r\n  width: 23%;\r\n  height: 90%;\r\n  top: 9%; */\r\n  \r\n  /* display: flex;\r\n  flex-direction: column;\r\n  grid-area: videopanel; */\r\n}\r\n\r\n.chatroom h3 {\r\n  /* font-family: 'Pacifico', cursive; */\r\n  background-color: rgba(127, 204, 242, 0.7);\r\n  color: #FFF;\r\n  margin: 0;\r\n  height: 40px;\r\n  font-size: 20px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.original-image{\r\n  user-drag: none;\r\n  -webkit-user-drag: none;\r\n  user-select: none;\r\n  -moz-user-select: none;\r\n  -webkit-user-select: none;\r\n  -ms-user-select: none;\r\n}\r\n\r\n.chatroom .chats {\r\n  box-sizing: border-box;\r\n  padding: 0 20px;\r\n  margin: 10px 0 0;\r\n  /* height:100%; */\r\n  height: calc(100% - 90px);\r\n  /* height: 87%; */\r\n  /* height: 600px; */\r\n  /* overflow-y: hidden; */\r\n  overflow-y: auto;\r\n  min-height: 50%;\r\n}\r\n\r\n.chatroom .chats .chat {\r\n  background: rgba(255, 255, 255, 0.8);\r\n  position: relative;\r\n  padding: 5px 13px;\r\n  font-size: 14px;\r\n  border-radius: 10px;\r\n  list-style: none;\r\n  float: left;\r\n  clear: both;\r\n  margin: 10px 0;\r\n  max-width: 250px;\r\n}\r\n\r\n.w-full {\r\n  width: 100%;\r\n}\r\n/* .h-full {\r\n  height: 100%;\r\n} */\r\n\r\n.full-screen-image{\r\n  width: 100%;\r\n  /* height: 100%; */\r\n  object-fit: contain;\r\n  position: absolute\r\n}\r\n.absolute{\r\n  position: absolute;\r\n}\r\n\r\n.pointer-events-none{\r\n  pointer-events: none;\r\n}\r\n\r\n.chatroom .chats .chat img {\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 50%;\r\n  position: absolute;\r\n  top: -10px;\r\n  left: 0px;\r\n}\r\n\r\n.chatroom .chats .chat.right {\r\n  float: right;\r\n  clear: both;\r\n}\r\n\r\n/*.chatroom .chats .chat a {\r\n  text-decoration: none;\r\n  color:#3498DB;\r\n}*/\r\n\r\n\r\n.chatroom .input {\r\n  min-height: 40px;\r\n  /* max-height: 100px; */\r\n  /* width: 100%; */\r\n  background: rgba(147, 215, 249, 0.7);\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n\r\n  /* position: absolute;\r\n  bottom: 0; */\r\n}\r\n\r\n/* */\r\n  \r\n.chatroom .input input[type=\"text\"] {\r\n  background: rgba(255, 255, 255, 0.5);\r\n  outline: 0;\r\n  border: 2px solid #9ad4ed;\r\n  padding: 0 5px;\r\n  border-top-left-radius: 5px;\r\n  border-bottom-left-radius: 5px;\r\n  margin-left: 10px;\r\n  height: 30px;\r\n  width: 230px;\r\n  box-sizing: border-box;\r\n  font-size: 14px;\r\n}\r\n\r\n.chatroom .input  img[type=\"popup\"] {\r\n  background: transparent;\r\n  border: 1px solid #9ad4ed;\r\n  height: 30px;\r\n  width: 30px;\r\n  font-size: 14px;\r\n  box-sizing: border-box;\r\n  /* border-top-right-radius: 5px;\r\n  border-bottom-right-radius: 5px; */\r\n  transition: all 0.3s ease;\r\n\r\n}\r\n.chatroom .input  img[type=\"popup\"]:hover {\r\n  cursor: pointer;\r\n  background: #9ad4ed;\r\n  color: #FFF;\r\n}\r\n.chatroom .input input[type=\"button\"] {\r\n  background: transparent;\r\n  border: 1px solid #9ad4ed;\r\n  height: 40px;\r\n  /* width: 80px; */\r\n  font-size: 14px;\r\n  box-sizing: border-box;\r\n  /* border-top-right-radius: 5px;\r\n  border-bottom-right-radius: 5px; */\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n\r\n.chatroom .input input[type=\"button\"]:hover {\r\n  background: #9ad4ed;\r\n  color: #FFF;\r\n}\r\n  \r\n.chatroom #button{\r\n  background: transparent;\r\n  border: 1px solid #9ad4ed;\r\n  /* margin-right: 10px; */\r\n  height: 40px;\r\n  /* width: 50px; */\r\n  font-size: 14px;\r\n  box-sizing: border-box;\r\n  border-top-right-radius: 5px;\r\n  border-bottom-right-radius: 5px;\r\n  transition: all 0.3s ease;\r\n}\r\n  \r\n.chatroom .input input[type=\"submit\"]:hover {\r\n  background: #9ad4ed;\r\n  color: #FFF;\r\n}\r\n\r\n.modal {\r\n  display: none;\r\n  position: fixed;\r\n  z-index: 1;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0,0,0,0.25);\r\n  overflow: scroll;\r\n}\r\n  \r\n.modal_content {\r\n    background-color: white;\r\n    position: absolute;\r\n    top: 20%;\r\n    left: 25%;\r\n    width: 50%;\r\n    height: 100%;\r\n    padding: 20px;\r\n    border-radius: 5px;\r\n    border: 2px solid black;\r\n  }\r\n\r\n.default-button:hover, .group-button:hover{\r\n    color: #FFFFFF;\r\n    background-color: darkmagenta;\r\n    transition-duration: 0.5s;\r\n}\r\n  \r\n.content { \r\n      /* display: none;  */\r\n    position: fixed; \r\n    top: 30%; \r\n    left: 18%; \r\n    width: 65%; \r\n    height: 60%; \r\n    /* padding: 20px;  */\r\n    background-color: white; \r\n    z-index:999; \r\n    overflow: auto; \r\n    /* transform: translate(-10%, -10%); */\r\n    /* margin:auto; */\r\n    /* border-top-right-radius: 10px;\r\n    border-bottom-right-radius: 10px;\r\n    border-top-left-radius: 10px;\r\n    border-bottom-left-radius: 10px; */\r\n    border: 1.5px solid black; ;\r\n} \r\n\r\n#gallery  {\r\n  position: relative;\r\n  background-color: #FFFFFF;\r\n  overflow: scroll;\r\n  border: 1px #6C757D solid;\r\n  border-radius: 5px;\r\n  /* margin: auto; */\r\n  margin:8px;\r\n  width: 95%;\r\n  height: 250px;\r\n  bottom: 300px;\r\n}\r\n\r\n/* #float-span:hover{\r\n  cursor: pointer;\r\n  border-top: 10px solid aquamarine;    \r\n} */\r\n\r\n#float-span:hover{\r\n  cursor: pointer;\r\n  border-left: 10px solid aquamarine;    \r\n}\r\n\r\n.thingmoji{\r\n  float: left;\r\n  margin: 2px;\r\n  /* position:absolute */\r\n}\r\n\r\n:root{\r\n  --pseudo-border-bottom: \"\";\r\n  --pseudo-border-top:\"10px solid white\";\r\n  --pseudo-bottom:\"-10px\";\r\n  --pseudo-top:\"\";\r\n}\r\n\r\n.image-bubble::after{\r\n    content: '';\r\n    position: absolute;\r\n    bottom: var(--pseudo-bottom);\r\n    top:var(--pseudo-top);\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    width: 0;\r\n    height: 0;\r\n    border-left: 10px solid transparent;\r\n    border-right: 10px solid transparent;\r\n    border-top: var(--pseudo-border-top);\r\n    border-bottom: var(--pseudo-border-bottom);\r\n}\r\n.thingmoji:hover{\r\n  cursor: pointer;\r\n  transform: scale(1.1);\r\n}\r\n\r\n#image-peek{\r\n  position: absolute;\r\n  /* display: inline-block; */\r\n  border-radius: 10px;\r\n  background-color: white;\r\n  border: 1px solid #ccc;\r\n  padding: 10px;\r\n  position:absolute;\r\n  z-index:\"100\";\r\n   width: 100px;\r\n   height: 100px;\r\n  /* position:absolute */\r\n}\r\n#image-peek::after{\r\n  content: '';\r\n  position: absolute;\r\n  top: \"-10px\";\r\n  /* --pseudo-border-top:\"10px solid white\"; */\r\n  /* top:var(--pseudo-top); */\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 10px solid transparent;\r\n  border-right: 10px solid transparent;\r\n  border-bottom: \"10px solid white\";\r\n  /* border-bottom: var(--pseudo-border-bottom); */\r\n}\r\n\r\n.thingmoji-group {\r\n  background: transparent;\r\n  border: 1px solid #9ad4ed;\r\n  height: 30px;\r\n  width: 80px;\r\n  font-size: 14px;\r\n  box-sizing: border-box;\r\n  border-radius: 5px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.thingmoji-group:hover {\r\n  background: #9ad4ed;\r\n  color: #FFF;\r\n}\r\n\r\n#delete, #new {\r\n  background: #9ad4ed80;\r\n  color: #6C757D;\r\n  box-sizing: border-box;\r\n  border-radius: 5px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n#delete:hover, #new:hover {\r\n  background: #9ad4ed;\r\n  color: #FFFFFF;\r\n}\r\n\r\n.font {\r\n  font-family: \"Pacifico\", cursive;\r\n}\r\n\r\n.popup {\r\n  border: #6C757D solid 1px;\r\n  border-radius: 5px;\r\n  background-color: rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n*::-webkit-scrollbar {\r\n  width: 8px;\r\n  height: 8px;\r\n}\r\n*::-webkit-scrollbar-thumb {\r\n  border-radius: 5px;\r\n  box-shadow: inset 0 0 5px transparent;\r\n  background: #6C757D88;\r\n}\r\n*::-wbkit-scrollbar-track {\r\n  border-radius: 5px;\r\n  box-shadow: inset 0 0 5px transparent;\r\n  background: transparent;\r\n}\r\n*::-webkit-scrollbar-corner{\r\n  border-radius: 5px;\r\n  background-color: transparent;\r\n}\r\n*::-webkit-scrollbar-thumb:hover {\r\n  background: #6C757DCC;\r\n}\r\n*::-webkit-scrollbar-thumb:active {\r\n  background: #6C757D;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
